<template>
    <toggle-button
        v-bind="{color, labels, sync, value, width}"
        @input="sendRequest"
    ></toggle-button>
</template>

<script>
export default {
    name: 'ApiToggleButton',

    props: {
        color: {
            type: Object,
            default: () => ({
                checked: '#57b759',
                unchecked: '#9a9a9a',
            }),
        },
        endpoint: {
            type: String,
            required: false,
        },
        fieldName: {
            type: String,
            required: false,
        },
        labels: {
            type: Object,
            default: () => ({
                checked: 'Enabled',
                unchecked: 'Disabled',
            }),
        },
        startValue: {
            type: Boolean,
            required: true,
        },
        sync: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Number,
            default: 100,
        },
        config: {
            type: Object,
            default: () => ({}),
            required: false,
        },
    },

    data() {
        return {
            value: this.startValue,
        }
    },

    watch: {
        value(newVal) {
            this.$emit('input', newVal);
        },
    },

    methods: {
        sendRequest() {
            axios
                .put(this.endpoint, {[this.fieldName]: !this.value}, {...this.config})
                .then(response => this.value = !this.value)
                .catch(error => console.log(`there was an error`))
            ;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/ApiToggleButton.vue